import { apiClient } from '@/lib/api/client'

export interface NotionImportSummary {
  dry_run: boolean
  accounts_created: number
  categories_created: number
  incomes_imported: number
  expenses_imported: number
  savings_imported: number
  savings_skipped_zero: number
  total_income_amount: string | number
  total_expense_amount: string | number
  total_saving_amount: string | number
  account_balances: Record<string, string>
  checksum_warnings: string[]
  execution_time_ms?: number
}

export interface NotionImportResponse {
  status: 'success' | 'error'
  dry_run: boolean
  execution_time_ms: number
  summary: NotionImportSummary
  error_code?: string
  message?: string
}

export const importNotionZip = async (
  file: File,
  dryRun: boolean = false
): Promise<NotionImportResponse> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('dry_run', String(dryRun))

  const { data } = await apiClient.post<NotionImportResponse>(
    '/api/finances/import/notion/',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return data
}
